import { WithSequenceStatePropsType } from 'components/hoc/withSequenceState';
import withSequenceState from 'components/hoc/withSequenceState';
import { WithVirtualPageView } from 'components/hoc/withVirtualPageView';
import withVirtualPageView from 'components/hoc/withVirtualPageView';
import DashboardView from 'components/views/DashboardView';
import Sequences from 'defs/sequences';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators, getOverview, getPreviewImage, getProgram, getTodos } from 'store/dashboard';
import { actionCreators as layoutAC } from 'store/layout';
import { getCoach, getGender } from 'store/profile';
import { actionCreators as viewAC } from 'store/view';
import { SCROLL_ELEMENT_ID } from 'types/ScrollElementId';

export type StateToPropsType = {
	program: ReturnType<typeof getProgram>;
	overview: ReturnType<typeof getOverview>;
	todos: ReturnType<typeof getTodos>;
	coach: ReturnType<typeof getCoach>;
	previewImage: ReturnType<typeof getPreviewImage>;
};

export type DispatchToPropsType = typeof actionCreators & {
	doLockBody: typeof layoutAC.doLockBody;
	doUnlockBody: typeof layoutAC.doUnlockBody;
	doRestoreLastScrollPosition: typeof viewAC.doRestoreLastScrollPosition;
};

export const mapStateToProps = (state): StateToPropsType => ({
	program: getProgram(state),
	overview: getOverview(state),
	todos: getTodos(state),
	coach: getCoach(state),
	previewImage: getPreviewImage(state, getGender(state)),
});

export const mapDispatchToProps = (dispatch): DispatchToPropsType => {
	return bindActionCreators(
		{
			...actionCreators,
			doLockBody: layoutAC.doLockBody,
			doUnlockBody: layoutAC.doUnlockBody,
			doRestoreLastScrollPosition: viewAC.doRestoreLastScrollPosition.bind(null, SCROLL_ELEMENT_ID.DASHBOARD),
		},
		dispatch
	);
};

export type ContainerDashboardViewPropsType = StateToPropsType &
	DispatchToPropsType &
	WithSequenceStatePropsType &
	WithVirtualPageView;

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withSequenceState(withVirtualPageView(DashboardView as any), [Sequences.DASHBOARD_MEASUREMENT_UPDATING]) as any);
